<template>
    <div id="PublicIndex" class="PublicIndex">
        <img :src="list.logo" alt="" class="banner-img" ondragstart="return false;" oncontextmenu="return false;">
        <div class="banner">
            <div class="banner-description">
            <div class="name">{{list.title1}}</div>
             <div class="description">{{list.title1s}}</div>
           </div>
        </div>
           <div class="item-gradient">
            <div class="p-lg">
                <i class="icon-al-applicationgroup"></i>
                <h1>{{list.title1}}</h1>
                 <h3>{{list.title1s}}</h3>
                    <div class="endowloadDetail-description-btn flex align-cen">
                </div>
            </div>
        </div>
        <div class="addBox flex align-cen" v-if="$route.query.type == 8">
            <div class="add-row"
             v-for="(item,index) in addInfo"
            :key="index"
            :class="{ addactive: currentNav1 == index }"
            @click="tabAdd(index,item)"
            >
            <div class="add-row-name flex align-cen">
                {{item.name}}
            </div>
            <div class="add-row-name1 flex align-cen">
                <img src="../../assets/images/addicon.png" alt="">
                <p>{{item.add}}</p>
            </div>
            <div class="add-row-name2 flex align-cen" v-if="item.phone">
                <img src="../../assets/images/addicon2.png" alt="">
               <p>{{item.phone}}</p>
            </div>
            </div>
            <bdmap  :sendformLabelAlign="contact" :showType='1' ref="Pbdmap"></bdmap>
        </div>
             <div class="endowloadDetail-contaniner" v-if="platformAppContentList && platformAppContentList.length >0" id="nr1" >
          <div class="ace-dbl-nav-channel" :class="{ fixed: isFixed }">
              <div class="mod">
                <div class="inner flex align-cen" :class="{ inner1: platformAppContentList && platformAppContentList.length == 1 }">
                <div class="nav-text"
                 v-for="(item,index) in platformAppContentList"
                :key="index"
                :class="{ active: currentNav == index }"
                @click="toBox(index)"
                >{{item.title}}</div>
                </div>
                </div>
          </div>
            <div class="scene j-content" 
                      v-for="(item,index) in platformAppContentList"
                    :key="index"
             >
                  <div class="quedior">
                        <h2>{{item.title}}</h2>
                        <div class="subtitle ">{{item.subhead}}</div>
                        <div v-html="item.content" class="nr"></div>
                    </div>
             </div>
         </div>
            <div class="endowloadDetail-contaniner endowloadDetail-contaniner1" v-else>
            <span class="icon-al-wind-cry"></span>
            <p>暂无数据</p>
        </div>
        <goTop></goTop>
    </div>
</template>
<script>
import {softList} from "@/api/enterprise/index" // 配置详情
import debounce from '../../utils/debounce.js' //防抖
import goTop from '@/components/goTop'
import { regionData, CodeToText, TextToCode } from 'element-china-area-data'  //省市区级联
import bdmap from "@/components/BdMap"  //地图组件
export default {
    name:'PublicIndex',
     components:{
        goTop,
        bdmap
    },
    data () {
        return {
            addInfo:[
                {
                    name:'北京总部',
                    add:'北京市海淀区北清路81号中关村壹号B1座801',
                    phone:'010-82926605/82926705',
                    longi:116.25435,
                    lati:40.08225
                },{
                    name:'南京睿首智能技术研究院有限公司',
                    add:'南京经济技术开发区恒泰路8号汇智科技园B1栋6层',
                    phone:'025-85567682',
                    longi:118.90347,
                    lati:32.15928
                },{
                    name:'山东和隆优化智能科技有限公司',
                    add:'山东省济南市槐荫区绿地中央广场C-1B栋13层 ',
                    phone:'0531-88808256',
                    longi:116.90430,
                    lati:36.66927 
                },{
                    name:'西安办事处',
                    add:'陕西省西安市未央区太华北路甲字88号锦园国际广场7层702室',
                    longi:108.97347,
                    lati:34.31711
                },{
                    name:'呼和浩特办事处',
                    add:'呼和浩特市玉泉区闻都城市广场17F座709-710室',
                    longi:111.68535,
                    lati:40.78510
                },{
                    name:'沈阳办事处',
                    add:'沈阳市铁西区千缘财富商汇B座1908',
                    longi:123.38768,
                    lati:41.81528
                },{
                    name:'鄂尔多斯办事处',
                    add:'鄂尔多斯市康巴什区乌兰木伦大街西三号华莹馨城A座商务楼五层501室',
                    longi:109.79569183553,
                    lati:39.611633311350
                }
            ],
            contact:{
                address:'',
                longi:'',
                lati:''
            },
            selectedOptions:[],
            platformAppContentList:[],
            list:{
                logo:'',
                title1:'',
                title1s:'',
                address:''
            },
             tabPosition:'top',
            isFixed: false,
            isClick:false,
            contentTopList:[],
             currentNav:0,
             currentNav1:0
        }
    },
     mounted() {
    window.addEventListener('scroll', this.handleScroll) // 监听滑动事件
  },
    created () {
         document.title = "关于我们"
        this.contact = {
            address:this.addInfo[0].add,
            longi:this.addInfo[0].longi,
            lati:this.addInfo[0].lati
        }
        this.getDetail()
    },
    methods: {
        // 切换地图
        tabAdd(index,data){
            this.currentNav1 = index
            this.contact = {
            address:data.add,
            longi:data.longi,
            lati:data.lati
            }
        this.$refs.Pbdmap.loadMap(data.longi,data.lati)
        },
                // 点击tab
    toBox(index) {
    // 点击滚动到指定的位置，要去掉滚动的过程中因为位置变化带来的效果
      this.isClick = true
      this.currentNav = index
      const DOM = document.querySelectorAll('.j-content')[index]
      const offsetTop = DOM.offsetTop - 50
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      })
       // 过一段时间，把isClick还原
      setTimeout(() => {
        this.isClick = false
      }, 800)
    },
                // 处理滚动
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      var offsetTop 
      var strof = this.$route.query.type == 8 ? '.addBox' : '.banner-img'
      offsetTop = document.querySelector(strof).offsetHeight
    //   if(this.$route.query.type == 3) offsetTop = 0
       // 获取所有锚点元素
      const divs = [...document.querySelectorAll('.j-content')]
      // 将所有锚点元素offsetTop push到数组内
      divs.forEach((item, index) => {
        this.contentTopList[index] = item.offsetTop - 50
        
      })
       // 判断当前是否是点击定位的，如果不是，才有滚动定位的效果
      if (!this.isClick) {
        let navIndex
        // 滚动定位tab高亮的状态
        for (let i = 0; i < this.contentTopList.length; i++) {
          // 如果当前滚动的top坐标大于第i个的top坐标，就记录下i。记录到最后，i就会是最后一个满足条件的i，也就是刚刚好的那个值
          if (scrollTop >= this.contentTopList[i]) {
            navIndex = i
          }
        }
        // 把下标赋值给 vue 的 data
        this.currentNav = navIndex
        if (typeof navIndex !== 'number') {
           this.currentNav = 0
        }
      }
      // 吸顶效果
        if (scrollTop > offsetTop) {
          this.isFixed = true
        } else {
          this.isFixed = false
        }
                  //防抖触发
        debounce(() => {
            this.$bus.$emit("fixedState",this.isFixed);
        }, 300)
         
    },
    // 获取详情
          getDetail(){
            this.platformAppContentList = []
              softList({id:this.$route.query.type},'enterprise')
                .then(res => {
                 res.data.forEach(item =>{

                     if(item.attributeName == "logo")   this.list.logo  = item.attributeValue
                    if(item.attributeName == "title1")  this.list.title1  = item.attributeValue
                    if(item.attributeName == "title1s") this.list.title1s  = item.attributeValue
                       if(item.attributeName == "address") this.list.address  = item.attributeValue
                    // if(item.attributeName == "alladdress") {
                    //   let allstr = item.attributeValue.split("-") 
                    // console.log(allstr)
                    // }
                 })
                // console.log(this.selectedOptions)
                 let contentData = res.data.filter(item => !item.attributeName.indexOf("content")),
                 temTitData = res.data.filter(item => !item.attributeName.indexOf("temTit")),
                 subheadData = res.data.filter(item => !item.attributeName.indexOf("subhead"))
                
                     contentData.forEach((item,index) =>{
                          if(item.attributeValue !=null){
                         if(index != item.attributeName.charAt(item.attributeName.length-1)) contentData.reverse(),temTitData.reverse(),subheadData.reverse()
                         this.platformAppContentList.push({
                          content:contentData[index].attributeValue,
                          title:temTitData[index].attributeValue,
                          subhead:subheadData[index].attributeValue ,
                        })
                          }
                     })
                })
                .catch(err => {                  
                })
        },
    },
       destroyed() {
    window.removeEventListener('scroll', this.handleScroll) // 销毁监听滑动事件
  },
}
</script>
<style lang="scss" scoped>
.PublicIndex{
    position: relative;
     .item-gradient{
        display: none;
    }
    .banner-img{
            width: 100%;
            height: 396px;
            object-fit: cover;
        }
    .banner{
        position: absolute;
        top:0px;
        width: 100%;
        height: 396px;
           .banner-description{
            position: absolute;
            left: 15%;
            top: 45%;
            color: #fff;
            .name{
                color: #171717;
                font-size: 40px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #171717;
                line-height: 50px;
            }
            .description{
                font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 300;
            color: #171717;
            line-height: 50px;
            }
                .btn{
                    margin-top: 20px;
                    max-width: 140px;
                    cursor: pointer;
                    border: none;
                    box-shadow: inset 0 0 1px 1px #000000;
                    font-weight: 400;
                    font-size: 18px;
                    text-align: center;
                    vertical-align: middle;
                    background-color: transparent;
                    border-radius: 5px;
                    margin-right: 20px;
                    padding: 5px 0;
                    color: #323233;
                    a{
                        color: #323233;
                    }
                }
                 .btn:hover{
                    background: linear-gradient(230.47deg, #FFA41C -0.87%, #FE4141 25.89%, #F4153E 77.87%, #FF27C3 97.94%), #E73828;
                    font-weight: 700;
                    box-shadow: none;
                    color: #FFFFFF;
                    a{
                       color: #FFFFFF; 
                    }
                 }
    }
    }
    .addBox{
        width: 1200px;
        margin: 50px auto;
        justify-content: space-between;
        flex-wrap: wrap;
        .add-row{
            width: 500px;
            height: 120px;
            margin-top: 10px;
            cursor: pointer;
            // padding: 20px 30px;
            border: 1px solid #F1F1F1;
             .add-row-name{
                padding-left: 70px;
                padding-top: 20px;
                   font-size: 14px;
                    color: #989898;
             }
            .add-row-name1,.add-row-name2{
                padding-left: 40px;
                img{
                    width: 20px;
                }
                p{
                    padding-left: 10px;
                    font-size: 14px;
                    color: #989898;
                }
            }
            .add-row-name2{
                padding-top: 0px;
            }
        }
        .addactive{
           border: 1px solid #2F54EB;
           .add-row-name{
                   font-size: 18px;
                    color: #323233;
                    font-weight: bold;
             }
        }
    }
}
::v-deep{
    .nr{
            p{
                img{margin: 0 auto !important;
                display: block;
                }
            }
        }
}
@media (max-width: 640px){
     .banner{display: none;}
        .banner-img{
        position: relative !important;
    width: 100%;
   
    background-repeat: no-repeat;
    background-position: top;
    background-size: cover;
    object-fit: cover;
        }
       .item-gradient{
        padding: 10px;
          display: block !important;
          margin-top: 20px;
          
       .p-lg{
        background: #FAFAFA;
       border-radius: 10px;
        transition: all .3s;
        padding: 30px;
        text-align: center;
        border:1px solid  #D0D0D0;
        i{
            color: #000;
            font-size: 40px;
        }
         .endowloadDetail-description-btn{
            justify-content: space-evenly;;
                div{
                     min-width: 140px;
                    cursor: pointer;
                    border: none;
                    box-shadow: inset 0 0 1px 1px #000000;
                    font-weight: 400;
                    font-size: 15px;
                    text-align: center;
                    vertical-align: middle;
                    background-color: transparent;
                    border-radius: 10px;
                   margin-top: 10px;
                    padding: 5px 0;
                    a{
                        color: #000;
                    }
                }
              
                 div:hover{
                    background: linear-gradient(230.47deg, #FFA41C -0.87%, #FE4141 25.89%, #F4153E 77.87%, #FF27C3 97.94%), #E73828;
                    font-weight: 700;
                    box-shadow: none;
                    color: #fff;
                    
                 }
            }
       }
    }
}
@media (max-width: 640px){
#PublicIndex{
  .banner-img{
    height: auto;
  }
  .addBox{
    width: 100%;
    .add-row{
        width: 90%;
        margin: 0 auto;
        margin-top: 10px;
        height: 140px !important;
    }
  }
}
}
</style>